<template>
  <div>
    <sub-content-container :title="$t('aboutMe.otherMerits.pageLabel')">
      <merit v-for="(merit, i) in completeMerits" :merit="merit" :key="`merit-${i}`" />
    </sub-content-container>
  </div>
</template>

<script>
const SubContentContainer = () =>
  import(
    /* webpackChunkName: "SubContentContainerComponent" */ "@/components/Global/SubContentContainer.vue"
  );
const Merit = () =>
  import(/* webpackChunkName: "OtherMeritsPage" */ "@/components/AboutMe/Merit.vue");

export default {
  name: "OtherMerits",
  components: {
    SubContentContainer,
    Merit
  },
  data() {
    return {
      merits: [{}, { youtubeEmbed: "https://www.youtube-nocookie.com/embed/NzqJhjDZLWw" }]
    };
  },
  computed: {
    completeMerits() {
      return this.merits.map((data, i) => {
        const youtubeEmbed = data.youtubeEmbed
          ? `${data.youtubeEmbed}?hl=${this.$i18n.locale}`
          : null;

        return {
          ...data,
          ...this.$t("aboutMe.otherMerits.merits")[i],
          youtubeEmbed
        };
      });
    }
  }
};
</script>
